<div style="flex: 100%;">
  <div class="display-flex display-layout-column">
    <div class="search-field display-layout-column layout-gap-15">
      <div class="display-layout-column justify-content-center align-items-start">
        <div class="display-layout-row layout-gap-10 layout-align-center-center" [formGroup]="searchForm">
          <mat-form-field>
            <mat-label>Search</mat-label>
            <input formControlName="filter" matInput (keyup)="applyFilter()" />
            <mat-icon matSuffix>search </mat-icon>
          </mat-form-field>
        </div>
      </div>
    </div>

    <table mat-table [dataSource]="dataSource" multiTemplateDataRows>
      <ng-container matColumnDef="arrow">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i = dataIndex" class="firstLine display-layout-row layout-gap-15"
          (click)="getRequestById(collapsedTable, element.id)">

          <div [ngClass]="{'new-messages': element.newMessages?.length > 0,
                        'not-new-messages': element.newMessages == null || element.newMessages?.length == 0}"></div>

          <div class="display-layout-row layout-align-center-center layout-gap-0">
            <button  mat-icon-button>
              <mat-icon>{{
                collapsedTable.id == element.id &&  collapsedTable.open
                ? "keyboard_arrow_up"
                : "keyboard_arrow_down"
              }}</mat-icon>
            </button>

            <div>
              @if (messagesLoading && collapsedTable.id == element.id) {
                <mat-spinner [diameter]="30"></mat-spinner>
              }
            </div>

          </div>

        </td>
      </ng-container>

      <ng-container matColumnDef="requestId">
        <th mat-header-cell *matHeaderCellDef>Request Id</th>
        <td mat-cell *matCellDef="let element" class="firstLine">
          <div class="display-layout-row layout-align-center-center">

            <div matTooltip="{{ element.requestID }}">
              {{getShortenedRequestId(element.requestID)}}
            </div>
            <div>
              <button [cdkCopyToClipboard]="element.requestID" matTooltip="Copy RequestID to clipboard" mat-icon-button
                (click)="$event.stopPropagation()">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="customerInfo">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let element">
          <div class="display-layout-column">
            <div class="firstLine">{{ element.customer?.companyName }}</div>
            <div class="secondLine">{{ element.customer?.email }}</div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="requestStatus">
        <th mat-header-cell *matHeaderCellDef>Request Status</th>

        <td mat-cell *matCellDef="let element">
          <mat-chip-list>
            <mat-chip [ngClass]="getStatusStyle(element.requestStatus)">
            {{ getStatus(element.requestStatus) }}</mat-chip>
          </mat-chip-list>
        </td>
      </ng-container>

      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef>Destination</th>
        <td mat-cell *matCellDef="let element">
          <div class="display-layout-column">
            <div class="firstLine destination">
              {{ element.finalDestination }}
            </div>
            <div class="secondLine">
              {{ element.availableExOrigin | date: 'dd/MM/yyyy' }}
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="packageInfo">
        <th mat-header-cell *matHeaderCellDef matTooltip="Packages/Weight">Package Information</th>
        <td mat-cell *matCellDef="let element">
          <div class="display-layout-column">
            <div class="firstLine">
              {{ element.numberOfParcels }} / {{ element.chargeableWeight }} kg
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="viewDetails">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-stroked-button [routerLink]="['/requests', element.id]">
            View Details
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>

        </th>
        <td mat-cell *matCellDef="let row; let column; let i = index">
          <button [matMenuTriggerFor]="menu" mat-icon-button>
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="deleteRequest(row, i)">
              Delete
            </button>

            <button mat-menu-item (click)="closeRequest(row)">
              {{ row.closed ? "Open Request" : "Close Request" }}
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <!-- DETAIL TABLE-->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <!--div class="example-element-detail" [@detailExpand]="
                element == detailData && element.messages
                  ? 'expanded'
                  : 'collapsed'
              ">-->
          <div class="example-element-detail"
            [@detailExpand]="element == detailData && messageRequest?.messages ? 'expanded' : 'collapsed' ">
            <table class="detailTable" mat-table [dataSource]="messageRequest?.messages">

              <ng-container matColumnDef="sendDate">
                <th mat-header-cell *matHeaderCellDef>Send Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.sentDateTime | date: 'dd/MM/yyyy, H:mm' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="receivedDate">
                <th mat-header-cell *matHeaderCellDef>Received Date</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.receivedDateTime | date: 'dd/MM/yyyy H:mm' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="receivedFrom">
                <th mat-header-cell *matHeaderCellDef>From</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.from?.emailAddress.address }}
                </td>
              </ng-container>

              <ng-container matColumnDef="sendTo">
                <th mat-header-cell *matHeaderCellDef>To</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.toRecipients[0]?.emailAddress?.address }}
                </td>
              </ng-container>

              <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef>Subject</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.subject }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedDetailColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedDetailColumns"></tr>
            </table>
          </div>
        </td>
      </ng-container>
      <!-- DETAIL TABLE END-->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns" class="example-element-row"
        [class.example-expanded-row]="detailData === element" (click)="
        messageRequest?.messages ? collapseTable(element.id) : null;
            detailData =
              detailData === element && messageRequest?.messages ? null : element
          "></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

      <!--When there is no matching filter data-->
      <tr class="mat-row no-data-found" *matNoDataRow>
        No data matching the filter {{ searchForm.controls.filter.value? " 'searchForm.value.filter' " : ' '}}
      </tr>
    </table>


    <div class="display-layout-row justify-content-end align-items-center">
      <div>
        @if (paginationSpinnerStarted) {
          <app-paginator-spinner></app-paginator-spinner>
        }
      </div>
      <mat-paginator #paginator (page)="pageChangeEvent($event)" [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize" showFirstLastButtons [length]="resultsLength">
      </mat-paginator>

    </div>
  </div>

</div>
